export const NAME = 'dashboard';